/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GitHubReadCloneResult = {
  sessionId: string;
  assignmentGeneration: number;
  repositoryId: number;
  owner: string;
  repository: string;
  baseSha: string;
};

/** @internal */
export const GitHubReadCloneResult$inboundSchema: z.ZodType<
  GitHubReadCloneResult,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  assignment_generation: z.number().int(),
  repository_id: z.number().int(),
  owner: z.string(),
  repository: z.string(),
  base_sha: z.string(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "assignment_generation": "assignmentGeneration",
    "repository_id": "repositoryId",
    "base_sha": "baseSha",
  });
});
/** @internal */
export type GitHubReadCloneResult$Outbound = {
  session_id: string;
  assignment_generation: number;
  repository_id: number;
  owner: string;
  repository: string;
  base_sha: string;
};

/** @internal */
export const GitHubReadCloneResult$outboundSchema: z.ZodType<
  GitHubReadCloneResult$Outbound,
  z.ZodTypeDef,
  GitHubReadCloneResult
> = z.object({
  sessionId: z.string(),
  assignmentGeneration: z.number().int(),
  repositoryId: z.number().int(),
  owner: z.string(),
  repository: z.string(),
  baseSha: z.string(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    assignmentGeneration: "assignment_generation",
    repositoryId: "repository_id",
    baseSha: "base_sha",
  });
});

export function gitHubReadCloneResultToJSON(
  gitHubReadCloneResult: GitHubReadCloneResult,
): string {
  return JSON.stringify(
    GitHubReadCloneResult$outboundSchema.parse(gitHubReadCloneResult),
  );
}
export function gitHubReadCloneResultFromJSON(
  jsonString: string,
): SafeParseResult<GitHubReadCloneResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GitHubReadCloneResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GitHubReadCloneResult' from JSON`,
  );
}
